import { getSiteProps } from "@/utils/siteProps";
import { Buffer } from "buffer";

import { getCookie } from "./cookies";

export const getHeaders = (url: string, isFormData?: boolean) => {
  const siteContext = getSiteProps(url);

  const commonHeader = {
    "Content-Type": "application/json; charset=utf-8",
    "Access-Control-Allow-Origin": "*",
    "x-source-site-context": siteContext?.site_map ?? "rexmonster",
    "x-language-code": "EN",
    origin: "https://qa1.foundit.in",
    referer: "https://qa1.foundit.in",
  };

  if (isFormData) {
    // @ts-ignore
    delete commonHeader["Content-Type"];
  }

  const mssoatCookie = getCookie("MSSOAT");
  const msuidCookie = getCookie("MSUID");

  if (!mssoatCookie) {
    return {
      Cookie: `MSUID=${msuidCookie}`,
      ...commonHeader,
    };
  }

  const decodedCookie = Buffer.from(mssoatCookie, "base64").toString("utf-8");
  const encryptedCookies = decodedCookie.split("::")[0];

  return {
    Cookie: `MSUID=${msuidCookie};MSSOAT=${mssoatCookie}`,
    Authorization: `Bearer ${encryptedCookies}`,
    ...commonHeader,
  };
};
